import type { ReactElement } from 'react';

import { SectionWrap } from '@/components/store/components/SectionWrap/SectionWrap';

import {
  Column,
  ColumnTitle,
  ComparisonGrid,
  ComparisonWrapper,
  EmojiIcon,
  Item,
  ItemText,
  Title,
} from './Comparison.styled';

export const Comparison = (): ReactElement => (
  <SectionWrap>
    <ComparisonWrapper>
      <Title>
        Czy nie mogę po prostu przeczytać darmowych materiałów z&nbsp;Internetu?
        <div style={{ fontSize: '24px' }}>…albo zapytać Chata GPT?</div>
      </Title>

      <ComparisonGrid>
        <Column type="cons">
          <ColumnTitle>😖 Przypadkowe treści w Internecie</ColumnTitle>
          <Item>
            <EmojiIcon>❌</EmojiIcon>
            <ItemText>Te same miejsca na każdym blogu</ItemText>
          </Item>
          <Item>
            <EmojiIcon>❌</EmojiIcon>
            <ItemText>Niesprawdzone treści</ItemText>
          </Item>
          <Item>
            <EmojiIcon>❌</EmojiIcon>
            <ItemText>Brak aktualnych informacji</ItemText>
          </Item>
          <Item>
            <EmojiIcon>❌</EmojiIcon>
            <ItemText>Brak realnych doświadczeń i rekomendacji</ItemText>
          </Item>
          <Item>
            <EmojiIcon>❌</EmojiIcon>
            <ItemText>Lanie wody, sztuczne nabijanie „stron”</ItemText>
          </Item>
        </Column>

        <Column type="pros">
          <ColumnTitle>🤩 Teneryfa. Praktyczny przewodnik</ColumnTitle>
          <Item>
            <EmojiIcon>✅</EmojiIcon>
            <ItemText>Treści z doświadczenia, nie Wikipedii</ItemText>
          </Item>
          <Item>
            <EmojiIcon>✅</EmojiIcon>
            <ItemText>Praktyczne porady</ItemText>
          </Item>
          <Item>
            <EmojiIcon>✅</EmojiIcon>
            <ItemText>Interaktywne mapy</ItemText>
          </Item>
          <Item>
            <EmojiIcon>✅</EmojiIcon>
            <ItemText>Gotowe plany zwiedzania</ItemText>
          </Item>
          <Item>
            <EmojiIcon>✅</EmojiIcon>
            <ItemText>Przykładowe szlaki i trasy spacerowe</ItemText>
          </Item>
          <Item>
            <EmojiIcon>✅</EmojiIcon>
            <ItemText>
              Lista sprawdzonych restauracji (również wegetariańskich)
            </ItemText>
          </Item>
          <Item>
            <EmojiIcon>✅</EmojiIcon>
            <ItemText>Darmowe aktualizacje</ItemText>
          </Item>
          <Item>
            <EmojiIcon>✅</EmojiIcon>
            <ItemText>
              Osobiste, sprawdzone wskazówki i triki, których nie znajdziesz
              nigdzie indziej
            </ItemText>
          </Item>
        </Column>
      </ComparisonGrid>
    </ComparisonWrapper>
  </SectionWrap>
);
